import React from 'react';
import * as Styles from 'components/manage-vm/settings-panel/SettingsPanel.style';
import CustomButton from 'components/common/custom-button';
import { useTranslation } from 'react-i18next';
import { P } from 'components/reusable-css';

const NewPassword = ({ loading, refreshServer }) => {
  const { t } = useTranslation();
  return (
    <Styles.ActionDiv>
      <Styles.DestroyText>
        <P>{t('vs/instance.string107')}</P>
      </Styles.DestroyText>
      <CustomButton
        title={'vs/instance.string108'}
        isLoading={loading}
        onClick={async () => await refreshServer('resetpw')}
      />
    </Styles.ActionDiv>
  );
};

export { NewPassword };
